export default __webpack_public_path__ + "assets/icon-pdf.e3ce8a13.webp";